import { c as _c } from "react/compiler-runtime";
// Общие примитивы оформления заказа по макету «5.1 Оформление заказа»
// (кадры 3924:18318, 3924:19172, 3926:21341): модалка 440 r20 — шапка 56
// (отступ 16, заголовок 20/24 w700 по центру, крестик 24 справа), тело с
// отступами 10/16/16; кнопки 408×48 r12 (светлая — #989AA2 12 %, тёмная —
// #2E2E2E, 16/21 w600), поля h40 r20 на #1F1F1F 3 % с подписью 12/16 w500,
// радио 20 и чекбокс 20 r6.
import { CloseIcon, XSmall16Icon } from "@/components/icons";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { TextField } from "@/components/ui/text-field";
import { cn } from "@/lib/utils";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@osmix/ui/dialog";
import { useId } from "react";
export function CheckoutModal(t0) {
  const $ = _c(25);
  const {
    open,
    onOpenChange,
    title,
    children,
    className,
    testId
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("flex max-h-[calc(100dvh-2rem)] w-[440px] max-w-[calc(100%-2rem)] flex-col gap-0 overflow-y-auto rounded-[20px] border-0 bg-white p-0 shadow-none sm:max-w-[440px]", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  if ($[2] !== title) {
    t2 = <DialogTitle className="text-center text-[20px] leading-6 font-bold tracking-[-0.6px] text-ds-ink">{title}</DialogTitle>;
    t3 = <DialogDescription className="sr-only">{title}</DialogDescription>;
    $[2] = title;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] !== onOpenChange) {
    t4 = () => onOpenChange(false);
    $[5] = onOpenChange;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <CloseIcon size={24} />;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t4) {
    t6 = <button type="button" onClick={t4} aria-label={"\u0417\u0430\u043A\u0440\u044B\u0442\u044C"} className="absolute top-1/2 right-4 grid size-6 -translate-y-1/2 place-items-center rounded-full text-ds-primary outline-none transition-colors hover:text-ds-primary/70 focus-visible:ring-2 focus-visible:ring-ds-focus">{t5}</button>;
    $[8] = t4;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t2 || $[11] !== t3 || $[12] !== t6) {
    t7 = <div className="relative flex min-h-14 shrink-0 items-center justify-center px-12 py-4">{t2}{t3}{t6}</div>;
    $[10] = t2;
    $[11] = t3;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== children) {
    t8 = <div className="flex flex-col px-4 pt-2.5 pb-4">{children}</div>;
    $[14] = children;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t1 || $[17] !== t7 || $[18] !== t8 || $[19] !== testId) {
    t9 = <DialogContent showCloseButton={false} overlayClassName="bg-black/20 backdrop-blur-[2px]" data-testid={testId} className={t1}>{t7}{t8}</DialogContent>;
    $[16] = t1;
    $[17] = t7;
    $[18] = t8;
    $[19] = testId;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== onOpenChange || $[22] !== open || $[23] !== t9) {
    t10 = <Dialog open={open} onOpenChange={onOpenChange}>{t9}</Dialog>;
    $[21] = onOpenChange;
    $[22] = open;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  return t10;
}

// Кнопка окна 408×48 r12 — DS `Button` размера lg на всю ширину: светлая —
// gray (#989AA2 12 %), тёмная — dark. Неактивная у обеих серая.
export function ModalButton(t0) {
  const $ = _c(10);
  let children;
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      children,
      variant: t1,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
    $[4] = t1;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
    t1 = $[4];
  }
  const variant = t1 === undefined ? "light" : t1;
  const t2 = variant === "dark" ? "dark" : "gray";
  let t3;
  if ($[5] !== children || $[6] !== className || $[7] !== props || $[8] !== t2) {
    t3 = <Button {...props} variant={t2} size="lg" block={true} className={className}>{children}</Button>;
    $[5] = children;
    $[6] = className;
    $[7] = props;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}

// Поле окна — DS `TextField` (подпись 12/16 w500 #171A24 64 %, поле h40 r20,
// чёрная обводка в фокусе), крестик очистки 16 справа при непустом значении
// (`trailing={null}` — без крестика), зелёная обводка для проверенного ввода.
export function ModalField(t0) {
  const $ = _c(19);
  const {
    label,
    value,
    onChange,
    placeholder,
    inputMode,
    type,
    className,
    valid,
    error,
    autoFocus,
    trailing,
    onBlur,
    testId
  } = t0;
  let t1;
  if ($[0] !== onChange || $[1] !== value) {
    t1 = value ? <button type="button" tabIndex={-1} aria-label={"\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C"} onClick={() => onChange("")} className="grid size-4 place-items-center rounded-full text-ds-primary hover:text-ds-primary/70"><XSmall16Icon size={16} /></button> : null;
    $[0] = onChange;
    $[1] = value;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const clear = t1;
  const t2 = type ?? "text";
  let t3;
  if ($[3] !== onChange) {
    t3 = e => onChange(e.target.value);
    $[3] = onChange;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = error || undefined;
  const t5 = valid && !error ? "border-ds-success focus-within:border-ds-success" : undefined;
  const t6 = trailing === undefined ? clear : trailing;
  let t7;
  if ($[5] !== autoFocus || $[6] !== className || $[7] !== inputMode || $[8] !== label || $[9] !== onBlur || $[10] !== placeholder || $[11] !== t2 || $[12] !== t3 || $[13] !== t4 || $[14] !== t5 || $[15] !== t6 || $[16] !== testId || $[17] !== value) {
    t7 = <TextField containerClassName={className} label={label} value={value} type={t2} inputMode={inputMode} placeholder={placeholder} autoFocus={autoFocus} onBlur={onBlur} data-testid={testId} onChange={t3} error={t4} fieldClassName={t5} end={t6} />;
    $[5] = autoFocus;
    $[6] = className;
    $[7] = inputMode;
    $[8] = label;
    $[9] = onBlur;
    $[10] = placeholder;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
    $[16] = testId;
    $[17] = value;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
}

// Флажок с подписью 14/18 (примерка, частичный выкуп, баланс, согласия) — DS
// `Checkbox` 20 r5 внутри <label>: нажатие на подпись тоже переключает.
export function CheckRow(t0) {
  const $ = _c(20);
  const {
    checked,
    onChange,
    children,
    className,
    disabled,
    testId
  } = t0;
  const id = useId();
  let t1;
  if ($[0] !== className) {
    t1 = cn("flex items-start gap-2.5 text-left text-[14px] leading-[18px] text-ds-primary", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== onChange) {
    t2 = v => onChange?.(v === true);
    $[2] = onChange;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== checked || $[5] !== disabled || $[6] !== id || $[7] !== t2) {
    t3 = <Checkbox id={id} checked={checked} disabled={disabled} onCheckedChange={t2} className="mt-px" />;
    $[4] = checked;
    $[5] = disabled;
    $[6] = id;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const t4 = disabled ? "cursor-default" : "cursor-pointer";
  let t5;
  if ($[9] !== t4) {
    t5 = cn("min-w-0", t4);
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== children || $[12] !== id || $[13] !== t5) {
    t6 = <label htmlFor={id} className={t5}>{children}</label>;
    $[11] = children;
    $[12] = id;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t1 || $[16] !== t3 || $[17] !== t6 || $[18] !== testId) {
    t7 = <div className={t1} data-testid={testId}>{t3}{t6}</div>;
    $[15] = t1;
    $[16] = t3;
    $[17] = t6;
    $[18] = testId;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
}

// Радио 20: выбранное — заливка #FA5C2E с белой точкой, пустое — обводка
// #1F1F1F 24 %, недоступное — серая заливка (как DS radio-group: в строках
// списков радио рисуется внутри общей кнопки строки, поэтому без Radix).
// Малое радио 16 — список пунктов в полноэкранном выборе (кадр 3926:20709).
export function Radio(t0) {
  const $ = _c(10);
  const {
    checked,
    disabled,
    small
  } = t0;
  const t1 = small ? "size-4" : "size-5";
  const t2 = disabled ? "bg-ds-primary/12" : checked ? "bg-ds-accent" : "border border-ds-primary/24 bg-white";
  let t3;
  if ($[0] !== t1 || $[1] !== t2) {
    t3 = cn("grid shrink-0 place-items-center rounded-full", t1, t2);
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== checked || $[4] !== disabled || $[5] !== small) {
    t4 = (checked || disabled) && <span className={cn("rounded-full", small ? "size-1.5" : "size-2", disabled ? "bg-[#8A8A8B]/46" : "bg-white")} />;
    $[3] = checked;
    $[4] = disabled;
    $[5] = small;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <span aria-hidden="true" className={t3}>{t4}</span>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}

// Строка списка в модалке (получатель, адрес, ПВЗ): внутри плашки #F8F8F8 r12,
// отступ 10, радио 20 + текст 14/18 (промежуток 10), действия 20 через 16.
export function ListRow(t0) {
  const $ = _c(24);
  const {
    selected,
    disabled,
    onSelect,
    children,
    actions,
    note,
    testId
  } = t0;
  let t1;
  if ($[0] !== disabled || $[1] !== selected) {
    t1 = <Radio checked={selected} disabled={disabled} />;
    $[0] = disabled;
    $[1] = selected;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = disabled ? "text-[#8A8A8B]/46" : "text-[#1F1F1F]";
  let t3;
  if ($[3] !== t2) {
    t3 = cn("truncate text-[14px] leading-[18px]", t2);
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== children || $[6] !== t3) {
    t4 = <span className={t3}>{children}</span>;
    $[5] = children;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== note) {
    t5 = note && <span className="text-[12px] leading-4 text-[#E1574F]">{note}</span>;
    $[8] = note;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4 || $[11] !== t5) {
    t6 = <span className="flex min-w-0 flex-col">{t4}{t5}</span>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== disabled || $[14] !== onSelect || $[15] !== t1 || $[16] !== t6) {
    t7 = <button type="button" disabled={disabled} onClick={onSelect} className="flex min-w-0 flex-1 items-center gap-2.5 text-left outline-none disabled:cursor-default">{t1}{t6}</button>;
    $[13] = disabled;
    $[14] = onSelect;
    $[15] = t1;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== actions) {
    t8 = actions && <span className="flex shrink-0 items-center gap-4">{actions}</span>;
    $[18] = actions;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t7 || $[21] !== t8 || $[22] !== testId) {
    t9 = <div className="flex min-h-10 items-center gap-5 px-2.5 py-2.5" data-testid={testId}>{t7}{t8}</div>;
    $[20] = t7;
    $[21] = t8;
    $[22] = testId;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  return t9;
}
export function IconAction(t0) {
  const $ = _c(4);
  const {
    label,
    onClick,
    children
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== label || $[2] !== onClick) {
    t1 = <button type="button" aria-label={label} onClick={onClick} className="grid size-5 place-items-center rounded-[4px] text-[#1F1F1F] outline-none transition-colors hover:text-[#FA5C2E] focus-visible:ring-2 focus-visible:ring-osmix-tangelo/40">{children}</button>;
    $[0] = children;
    $[1] = label;
    $[2] = onClick;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}

// Маска телефона по макету: «+7(900)000-00-00». `ruPhoneMask` — из
// сохранённого номера (E.164/любые цифры, ведущие 7/8 срезаются у 11-значных),
// `ruPhoneTyped` — для ввода: префикс «+7» маски отбрасывается до разбора.
const formatRuDigits = (digits: string): string => {
  const d = digits.slice(0, 10);
  if (!d) return "";
  let out = `+7(${d.slice(0, 3)}`;
  if (d.length >= 3) out += ")";
  if (d.length > 3) out += d.slice(3, 6);
  if (d.length > 6) out += `-${d.slice(6, 8)}`;
  if (d.length > 8) out += `-${d.slice(8, 10)}`;
  return out;
};
export const ruPhoneMask = (input: string): string => {
  let d = input.replace(/\D/g, "");
  if (d.length === 11 && (d.startsWith("7") || d.startsWith("8"))) d = d.slice(1);
  return formatRuDigits(d);
};
export const ruPhoneTyped = (value: string, previous: string): string => {
  let raw = value.startsWith("+7") ? value.slice(2) : value;
  // Стирание скобки/дефиса маски удаляет и предыдущую цифру.
  if (value.length < previous.length && /\D$/.test(previous)) raw = raw.replace(/\D+$/, "").slice(0, -1);
  return formatRuDigits(raw.replace(/\D/g, ""));
};

// Маска → E.164 (+7XXXXXXXXXX) или "" пока номер неполный.
export const ruPhoneE164 = (masked: string): string => {
  const d = masked.replace(/\D/g, "").replace(/^7/, "");
  return d.length === 10 ? `+7${d}` : "";
};

// Телефон для строк списков: российский номер — маской макета, прочие как есть.
export const phoneLabel = (phone: string): string => {
  const d = phone.replace(/\D/g, "");
  return phone.startsWith("+7") && d.length === 11 ? ruPhoneMask(d) : phone;
};